import dayjs, { Dayjs } from "dayjs";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import EditIcon from "../../../../../assets/General/cloud-plus.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/General/plus.svg";

import SpecialistApi from "../../../../../api/specialistsApi";
import Input from "../../../../../components/Input/Input";
import Loader from "../../../../../components/Loader/Loader";
import MuiDatePicker from "../../../../../components/MuiDatePicker/MuiDatePicker";
import StandartButton from "../../../../../components/StandartButton/StandartButton";
import {
  documentExtensions,
  imageExtensions,
} from "../../../../../constans/filesExtensions";
import { ContextProvider } from "../../../../../contextProvider";
import { AppreciationCertificate } from "../../../../../types/TypeSpecialist";
import { compressFiles } from "../../../../../utils/compressionFile";
import Notify, { SuccesNotify } from "../../../../../utils/toaster";
import { CertificatesData } from "../../EducationSection";
import s from "../UpdateCertificatesModal.module.css";

type NewAppreciationData = {
  file: File | undefined;
  receiveDate: Date | undefined;
  organization: string;
  receivedFor: string;
};

type AppreciationProps = {
  specialistId: string;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  setNewCertificate?: Dispatch<SetStateAction<CertificatesData>>;
  setupUpdateCertificate?: (cert: any) => void;
  actionLoaders: {
    addedCertificate: boolean;
  };
  setActionLoaders: Dispatch<SetStateAction<{ addedCertificate: boolean }>>;
  setShowSendReviewRequestBtn?: Dispatch<SetStateAction<boolean>>;
  appreciationToUpdate?: AppreciationCertificate;
};

const Appreciation = ({
  appreciationToUpdate,
  specialistId,
  setModalOpen,
  setNewCertificate,
  setupUpdateCertificate,
  actionLoaders,
  setActionLoaders,
  setShowSendReviewRequestBtn,
}: AppreciationProps) => {
  const token = localStorage.getItem("token");
  const { userData } = useContext(ContextProvider);
  const [appreciationData, setAppreciationData] = useState<NewAppreciationData>(
    {
      file: undefined,
      receiveDate: undefined,
      organization: "",
      receivedFor: "",
    }
  );

  useEffect(() => {
    if (!appreciationToUpdate) return;
    setAppreciationData({
      file: undefined,
      receiveDate: appreciationToUpdate.receiveDate
        ? new Date(appreciationToUpdate.receiveDate)
        : undefined,
      organization: appreciationToUpdate.organization,
      receivedFor: appreciationToUpdate.receivedFor,
    });
  }, [appreciationToUpdate]);

  const createAppreciation = async () => {
    if (!token) return;
    const payload = {
      specialistId: specialistId,
      file: appreciationData.file!,
      receiveDate: appreciationData.receiveDate!,
      organization: appreciationData.organization,
      receivedFor: appreciationData.receivedFor,
    };
    setActionLoaders((prev) => ({ ...prev, addedCertificate: true }));
    const response = await SpecialistApi.uploadAppreciationCertificate(
      token,
      payload
    );
    setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
    if (response.status && response.certificate) {
      setShowSendReviewRequestBtn && setShowSendReviewRequestBtn(true);
      SuccesNotify("Certificate has been created");
      setModalOpen(false);
      setupUpdateCertificate && setupUpdateCertificate(response.certificate);
      setNewCertificate &&
        setNewCertificate((prev) => ({
          ...prev,
          apppreciation: prev.apppreciation
            ? [...prev.apppreciation, response.certificate!]
            : [response.certificate!],
        }));
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  const updateAppreciationCertificate = async () => {
    if (!token || !userData || !appreciationToUpdate) return;
    const payload = {
      specialistId: specialistId,
      userId: userData._id,
      file: appreciationData.file,
      updateData: {
        _id: appreciationToUpdate._id,
        receiveDate: appreciationData.receiveDate!,
        organization: appreciationData.organization,
        receivedFor: appreciationData.receivedFor,
      },
    };
    setActionLoaders((prev) => ({ ...prev, addedCertificate: true }));
    const response = await SpecialistApi.updateAppreciationCertificate(
      token,
      payload
    );
    setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
    if (response.status && response.certificate) {
      setShowSendReviewRequestBtn && setShowSendReviewRequestBtn(true);
      SuccesNotify("Certificate has been updated");
      setModalOpen(false);
      setupUpdateCertificate && setupUpdateCertificate(response.certificate);
      setNewCertificate &&
        setNewCertificate((prev) => ({
          ...prev,
          apppreciation: prev.apppreciation
            ? prev.apppreciation.map((item) => {
                if (item._id === appreciationToUpdate._id) {
                  return response.certificate!;
                }
                return item;
              })
            : [response.certificate!],
        }));
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  const handleCertificateChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];
      if (file && file.type.includes("pdf")) {
        setAppreciationData((prev) => ({
          ...prev,

          file: file,
        }));
      }
      if (file && !file.type.includes("pdf")) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setAppreciationData((prev) => ({
            ...prev,

            file: compressedFile.file,
          }));
        }
      }
    }
  };

  const validationNewCertificate = () => {
    if (
      (!appreciationData.file && !appreciationToUpdate) ||
      !appreciationData.receiveDate ||
      !appreciationData.organization.trim() ||
      !appreciationData.receivedFor.trim()
    ) {
      return false;
    }
    return true;
  };

  if (actionLoaders.addedCertificate) {
    return (
      <div className={s.loaderContainer}>
        <Loader size={100} />
      </div>
    );
  }

  return (
    <div className={`${s.container} ${s.appreciationContainer}`}>
      <div className={s.inputBlock}>
        <Input
          inputValue={appreciationData.organization}
          isVisible
          required
          onChangeInput={(value) =>
            setAppreciationData((prev) => ({
              ...prev,
              organization: value,
            }))
          }
          maxLength={150}
          lable={
            "Issuing organization " +
            `(${appreciationData.organization.length}/150)`
          }
        />
      </div>
      <div className={s.inputBlock}>
        <Input
          inputValue={appreciationData.receivedFor}
          isVisible
          required
          onChangeInput={(value) =>
            setAppreciationData((prev) => ({
              ...prev,
              receivedFor: value,
            }))
          }
          maxLength={150}
          lable={
            "Reason for appreciation" +
            `(${appreciationData.receivedFor.length}/150)`
          }
        />
      </div>
      <div className={s.dateBlock}>
        <span className={s.secondLable}>Date of receipt</span>
        <div className={s.dateInputBlock}>
          <div className={s.dateInput}>
            <MuiDatePicker
              value={
                appreciationData.receiveDate
                  ? dayjs(appreciationData.receiveDate)
                  : undefined
              }
              setValue={(value: Dayjs | null) =>
                setAppreciationData((prev) => ({
                  ...prev,
                  receiveDate: value?.toDate(),
                }))
              }
            />
          </div>
        </div>
      </div>
      <div className={s.uploadCertificateBlock}>
        <span className={s.headLable}>Certificate</span>
        <span className={s.secondLable}>
          Add a certificate in image or pdf format
        </span>
        <div className={s.uploadFilesActionBlock}>
          {(appreciationData.file || appreciationToUpdate?.file) && (
            <div>
              {appreciationData.file
                ? appreciationData.file.name
                : appreciationToUpdate?.file?.filename ?? "Certificate file"}
            </div>
          )}
          <label className={s.fileInputBlock}>
            <input
              style={{ display: "none" }}
              type="file"
              accept={[...imageExtensions, ...documentExtensions].join(", ")}
              multiple={false}
              onChange={handleCertificateChange}
            />
            {appreciationData.file || appreciationToUpdate?.file ? (
              <span className={s.updateAvatarBtn} role="button">
                <img src={EditIcon} alt="" />
                <span>Replace</span>
              </span>
            ) : (
              <div className={s.addCertificateBtn}>
                <PlusIcon />
                <span>Add certificate</span>
              </div>
            )}
          </label>
        </div>
      </div>
      <StandartButton
        action={
          appreciationToUpdate
            ? updateAppreciationCertificate
            : createAppreciation
        }
        buttonTitle={"Save"}
        width="100%"
        disabled={!validationNewCertificate()}
      />
    </div>
  );
};

export default Appreciation;
